/**
* @file 系统设置-顶部广告-新增/编辑广告
* */
<template>
  <div id="topForm">
    <el-dialog title="如何获取appid" :visible.sync="visibleAppid" width="900px" :close-on-click-modal="false" append-to-body>
      <div class="appid">
        <div>
          <div>第一步</div>
          <img src="@/assets/img/appid1.png" />
        </div>
        <div>
          <div>第二步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
        <div>
          <div>第三步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
      </div>
    </el-dialog>

    <h2>{{ `${id ? '编辑' : '新增'}广告` }}</h2>

    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="封面图片" prop="coverImg" class="custom-form-center">
        <up-img :file.sync="form.coverImg" :cut="false" width="200" height="100"></up-img>
      </el-form-item>
      <el-form-item label="跳转页面" prop="jumpType">
        <JumpTypeSelector
          :jumpType="form.jumpType"
          :jumpTo="form.jumpTo"
          @update:jumpType="jumpChange($event, 'jumpType')"
          @update:jumpTo="jumpChange($event, 'jumpTo')"
          @show-appid-info="visibleAppid = true"
        ></JumpTypeSelector>
    </el-form-item>
      <!-- <el-form-item label="是否启用"> 
              <el-switch v-model="form.coverImg" :active-value="1" :inactive-value="2"></el-switch>
            </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        <el-button @click="backClick">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import JumpTypeSelector from '../components/JumpTypeSelector.vue';
export default {
  name: "topForm",
  components: {
    JumpTypeSelector
  },
  data() {
    return {
      // 表单
      form: {
        jumpType: null,
        jumpTo: null
      },
      // 校验规则
      rules: {
        coverImg: [{ required: true, message: '请选择上传图片' }],
        jumpType: [{ required: true, message: '请选择跳转页面' }]
      },
      // 保存按钮loading
      loading: false,
      visibleAppid: false
    }
  },
  props: {
    id: Number,
    visible: Boolean
  },
  watch: {
    id: {
      handler(val) {
        val && this.getInfo()
      },
      immediate: true
    },
    visible(val) {
      if (!val) {
        this.form = { jumpTo: null }
      }
    }
  },
  methods: {
    jumpChange(val, name) {
      this.$set(this.form, name, val)
    },
    /* 选择封面 */
    imgClick(name) {
      this.$set(this.form, 'coverImg', name)
    },

    /* 保存 */
    saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.jumpType == 1 && !this.form.jumpTo) {
            this.$message.info('请填写appid');
            return;
          } else if (this.form.jumpType == 2 && !this.form.jumpTo) {
            this.$message.info('请填写网页链接');
            return;
          }  else if (this.form.jumpType == 5 && !this.form.jumpTo) {
            this.$message.info('请选择线路');
            return;
          }else if (this.form.jumpType == 3) {
            this.form.jumpTo = '旅游包车页面';
          }
          if (this.id) {
            this.putFn()
          } else {
            this.postFn()
          }
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    /* 接口请求-新增 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/banner/ad';
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    /* 接口请求-修改 */
    async putFn() {
      this.loading = true;
      let url = '/api/v1/manage/banner/ad';
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    /* 接口请求-详情 */
    async getInfo() {
      let url = '/api/v1/manage/banner/ad/' + this.id;
      let data = await this.$axios.get(url)
      if (data && data.code === 1) {
        this.form = data.data || {}
      }
    },

    backClick() {
      this.$emit('advertisingClose')
    }
  },
}
</script>

<style lang="less">
#topForm {
  padding: 0 24px 24px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-form {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
    
    .el-input__inner,
    .el-select .el-input__inner {
      border-radius: 6px;
    }
  }

  .radio-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .el-radio {
      flex-shrink: 0;
      width: 120px
    }
  }

  .radio-tips {
    margin: 0 0 20px 150px;
    font-size: 12px;
    color: #909399;

    span {
      color: #2B77FF;
      cursor: pointer;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 保存按钮区域
  .el-form-item:last-child {
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
    
    .el-button {
      min-width: 100px;
      border-radius: 6px;
    }
  }
}

.appid {
  padding: 20px 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 30px;

  > div {
    text-align: center;
    
    > div:first-child {
      color: #303133;
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 12px;
    }
  }

  img {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
  }
}
</style>
